export enum PATH {
  unknown_path = "unknown_path",
  diagnostic = "diagnostic",
  patient = "patient",
  exemption = "exemption",
  consultation_time = "consultation_time",
  remove_lenses = "remove_lenses",
  timeline_initialize = "timeline-initialize",
  timeline_anamnesis = "timeline-anamnesis",
  inform_anamnesis = "inform_anamnesis",
  anamnesis_questions = "anamnesis_questions",
  reason = "reason",
  reason_details = "reason:details",
  contact_lens_type = "reason:details:contact_lens_type",
  contact_lens_brand = "reason:details:contact_lens_type:contact_lens_brand",
  contact_lens_bending_radius = "reason:details:contact_lens_type:contact_lens_brand:contact_lens_bending_radius",
  contact_lens_diameter = "reason:details:contact_lens_type:contact_lens_brand:contact_lens_bending_radius:contact_lens_diameter",
  illness = "illness",
  illness_details = "illness:details",
  optic_illness = "optic_illness",
  optic_illness_details = "optic_illness:details",
  timeline_tutorial = "timeline-tutorial",
  tutorial = "tutorial",
  timeline_orthoptist = "timeline-orthoptist",
  payment = "payment",
  timeline_ophtalmologist = "timeline-ophtalmologist",
  doctor = "doctor",
  slot = "doctor:slot",
  allergy = "allergy",
  allergy_details = "allergy:details",
  operation = "operation",
  consent = "consent",
  drug = "drug",
  pregnant = "pregnant",
  ineligible = "ineligible",
  choice_of_doctor = "choice_of_doctor",
  choice_of_doctor_doctor_available = "choice_of_doctor:doctor_available",
  doctor_available = "doctor_available",
  call_ortho_on_going = "call_ortho_on_going",
  call_ophta_on_going = "call_ophta_on_going",
  selected_carer = "selected_carer",
}
